module.exports = __webpack_public_path__ + "img/mobile.37f1963d.png";